module.exports = "https://static.cdns.space/tarot-temp/img/blog3-6.b19c24c2.png";